/**
 * 本文件代码存储的是报价时不同品质对应的key
 */

/* 报价页面人保品质提示 */
export const QUOTE_QUALITY_TIP_PEOPLE_INSURANCE = {
  ORIGIN_FACTORY_ORIGIN_PACKAGE:'汽车生产商提供或认可的，使用汽车生产商品牌或其认可品牌，按照车辆组装零部件规格和产品标准制造，通过汽车生产商零部件销售公司(部门)或其授权销售网点(包括中心库、授权专卖店、4s店等)销售的零部件。带原厂配件编号、带有原厂车型品牌标志、带原厂包装。',
  ORIGIN_FACTORY_EASY_PACKAGE:'汽车生产商提供或认可的主机配套厂提供，使用汽车生产商品牌或其认可品牌，带标带号，包含进口期货配件(通过国外进口或其他渠道在国外生产的原厂配件)、大包装或工业包装配件。',
  OE:'通过汽车行业相关认证，具备OEM配套资质的生厂商生产的产品，带有生产厂家标识、注册商标标识、合格标识。',
  BRAND:'通过汽车行业相关认证，不具备OEM配套资质的生厂商生产的产品，带有生产厂家标识、注册商标标识、合格标识。',
  CAR_DISASSEMBLY_PART:'',
  DEPUTY_FACTORY:'',
  REMANUFACTURED_PARTS: '旧汽车零部件经过再制造技术、工艺生产后，性能和质量达到原型新品要求的零部件。',
}

/* 品牌代码、品牌名称、品牌简称，这三个目前只有品牌件的品质会有。记录时间：2025年1月20日 15点13分 */

/* 各品质报价小计的key, 这个暂时没用到。记录时间：2025年3月13日 15点58分 */
export const QUOTE_SUBTOTAL_RESULT = {
  ORIGIN_FACTORY_ORIGIN_PACKAGE:'ORIGIN_FACTORY_ORIGIN_PACKAGE__subtotalKey',
  ORIGIN_FACTORY_EASY_PACKAGE:'ORIGIN_FACTORY_EASY_PACKAGE__subtotalKey',
  OE:'OE__subtotalKey',
  BRAND:'BRAND__subtotalKey',
  CAR_DISASSEMBLY_PART:'CAR_DISASSEMBLY_PART__subtotalKey',
  DEPUTY_FACTORY:'DEPUTY_FACTORY__subtotalKey',
  REMANUFACTURED_PARTS: 'REMANUFACTURED_PARTS__subtotalKey',
};

/* 报价的不同品质的品牌代码 */
export const QUOTE_BRAND_CODE_RESULT = {
  ORIGIN_FACTORY_ORIGIN_PACKAGE:'',
  ORIGIN_FACTORY_EASY_PACKAGE:'',
  OE:'pt_brand_code',
  BRAND:'pp_brand_code',
  CAR_DISASSEMBLY_PART:'',
  DEPUTY_FACTORY:'',
  REMANUFACTURED_PARTS: '',
}

/* 报价的不同品质的品牌名称 */
export const QUOTE_BRAND_NAME_RESULT = {
  ORIGIN_FACTORY_ORIGIN_PACKAGE:'',
  ORIGIN_FACTORY_EASY_PACKAGE:'',
  OE:'pt_brand_name',
  BRAND:'pp_brand_name',
  CAR_DISASSEMBLY_PART:'',
  DEPUTY_FACTORY:'',
  REMANUFACTURED_PARTS: '',
}

/* 报价的不同品质的品牌简称 */
export const QUOTE_BRAND_ALIAS_NAME_RESULT = {
  ORIGIN_FACTORY_ORIGIN_PACKAGE:'',
  ORIGIN_FACTORY_EASY_PACKAGE:'',
  OE:'pt_brand_alias_name',
  BRAND:'pp_brand_alias_name',
  CAR_DISASSEMBLY_PART:'',
  DEPUTY_FACTORY:'',
  REMANUFACTURED_PARTS: '',
}

/* 比价提交选中的品质 */
export const QUALITY_FIRST_LETTER_STRING = {
    ORIGIN_FACTORY_ORIGIN_PACKAGE:'YBJ',
    ORIGIN_FACTORY_EASY_PACKAGE:'XXJ',
    OE:'PTJ',
    BRAND:'PPJ',
    CAR_DISASSEMBLY_PART:'CCJ',
    DEPUTY_FACTORY:'FCJ',
};
/* 比价提交选中的品质，某种情况某个属性存在多个的 */
export const QUALITY_FIRST_LETTER_STRING2 = {
  ORIGIN_FACTORY_ORIGIN_PACKAGE: [ 'YBJ', 'YCJ'],
  ORIGIN_FACTORY_EASY_PACKAGE: ['XXJ'],
  OE: ['PTJ'],
  BRAND: ['PPJ'],
  CAR_DISASSEMBLY_PART: ['CCJ'],
  DEPUTY_FACTORY: ['FCJ'],
};
export const QUALITY_RESULT = {
    ORIGIN_FACTORY_ORIGIN_PACKAGE:1,
    ORIGIN_FACTORY_EASY_PACKAGE:2,
    OE:3,
    BRAND:4,
    CAR_DISASSEMBLY_PART:5,
    DEPUTY_FACTORY:7,
};
/** 备注 */
export const PART_QUALITY_REMARK_RESULT = {
    ORIGIN_FACTORY_ORIGIN_PACKAGE: 'ybremark',
    ORIGIN_FACTORY_EASY_PACKAGE: 'xxremark',
    OE:'ptremark',
    BRAND:'ppremark',
    CAR_DISASSEMBLY_PART:'ccremark',
    DEPUTY_FACTORY:'fcremark',
};
export const QUALITY_CHINESE_NAME={
    ORIGIN_FACTORY_ORIGIN_PACKAGE:'原厂原包',
    ORIGIN_FACTORY_EASY_PACKAGE:'原厂简包',
    OE:'配套(OE)',
    BRAND:'品牌(知名品牌)',
    CAR_DISASSEMBLY_PART:'拆车',
    DEPUTY_FACTORY:'副厂(国产小品牌)',
    /* 再制造件也叫修复件，鑫卡盟暂时没有这个品质 */
}
export const QUALITY_CHINESE_HTML_NAME_RESULT={
    ORIGIN_FACTORY_ORIGIN_PACKAGE:'原厂原包<p style="color: red;font-weight: normal;font-size: 13px;">(4S店货带包装)</p>',
    ORIGIN_FACTORY_EASY_PACKAGE:'原厂简包',
    OE:'配套(OE)',
    BRAND:'品牌(知名品牌)',
    CAR_DISASSEMBLY_PART:'拆车',
    DEPUTY_FACTORY:'副厂(国产小品牌)',
}
/** 厂商 */
export const MANUFACTURER_FOR_STRING_RESULT={
    ORIGIN_FACTORY_ORIGIN_PACKAGE:'yb_cs',
    ORIGIN_FACTORY_EASY_PACKAGE:'xx_cs',
    OE:'pt_cs',
    BRAND:'pp_cs',
    CAR_DISASSEMBLY_PART:'cc_cs',
    DEPUTY_FACTORY: 'fc_cs',
};
/** 各品质价格的字段 */
export const QUALITY_PRICE_FOR_STRING_RESULT = {
    ORIGIN_FACTORY_ORIGIN_PACKAGE:'ybprice',
    ORIGIN_FACTORY_EASY_PACKAGE:'xxprice',
    OE:'ptprice',
    BRAND:'ppprice',
    CAR_DISASSEMBLY_PART:'ccprice',
    DEPUTY_FACTORY:'fcprice',
}
/* 比价接口价格字段 */
export const DEALER_QUOTE_FOR_STRING_RESULT = {
    ORIGIN_FACTORY_ORIGIN_PACKAGE:'pjsybj',
    ORIGIN_FACTORY_EASY_PACKAGE:'pjsxxj',
    OE:'pjsptj',
    BRAND:'pjsppj',
    CAR_DISASSEMBLY_PART:'pjsccj',
    DEPUTY_FACTORY:'pjsfcj',
}
/** 是否现货 */
export const IS_IT_IN_STOCK_FOR_STRING_RESULT = {
    ORIGIN_FACTORY_ORIGIN_PACKAGE: 'ybisgoods',
    ORIGIN_FACTORY_EASY_PACKAGE:'xxisgoods',
    OE:'ptisgoods',
    BRAND:'ppisgoods',
    CAR_DISASSEMBLY_PART:'ccisgoods',
    DEPUTY_FACTORY:'fcisgoods',
}

/**
 * 调货时间
 */
export const TRANSFER_TIME_RESULT = {
  ORIGIN_FACTORY_ORIGIN_PACKAGE: 'yb_transfer_time',
  ORIGIN_FACTORY_EASY_PACKAGE: 'xx_transfer_time',
  OE: 'pt_transfer_time',
  BRAND: 'pp_transfer_time',
  CAR_DISASSEMBLY_PART: 'cc_transfer_time',
  DEPUTY_FACTORY: 'fc_transfer_time',
  REMANUFACTURED_PARTS: 'xf_transfer_time',
}

/**
 * 质保期
 */
export const GUARANTEE_PERIOD_RESULT = {
  ORIGIN_FACTORY_ORIGIN_PACKAGE: 'yb_guarantee_period',
  ORIGIN_FACTORY_EASY_PACKAGE: 'xx_guarantee_period',
  OE: 'pt_guarantee_period',
  BRAND: 'pp_guarantee_period',
  CAR_DISASSEMBLY_PART: 'cc_guarantee_period',
  DEPUTY_FACTORY: 'fc_guarantee_period',
  REMANUFACTURED_PARTS: 'xf_guarantee_period',
}

export const SUBMIT_TYPE_CODE_IN_QUOTE_PRICE = {
    DONE:'xbwc',
    TEMPORARY_STORAGE: 'zc',
}